import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core'
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { ApiServiceBase } from '../../base/api-service-base';
import { AuthService } from '../../authentication/auth.service';
import { CommunicationOtherModel } from '../../models/reference-model/reference-general-model/communication-other.model';


@Injectable({
    providedIn: 'root'
})
export class CommunicationOtherService extends ApiServiceBase {
    private readonly PATH = "/system/CommunicationOthers"

    constructor(httpClient: HttpClient,
        authService: AuthService) {
        super(httpClient, authService);
    }

    public getAllEmails(): Observable<CommunicationOtherModel[]> {
        return this.httpGet<CommunicationOtherModel[]>(this.PATH + "/email", null)
            .pipe(
                map(res => res.body)
            )
    }

    public getEmailsByOrderHeader(orderId: string): Observable<CommunicationOtherModel[]> {
        return this.httpGet<CommunicationOtherModel[]>(this.PATH + "/email/order-header/" + orderId, null)
            .pipe(
                map(res => res.body)
            )
    }
}